import { AbstractControl } from '@angular/forms';

export default function CIValidator(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) return null;

  const ci = control.value.toString();
  if (ci.length == 7 || ci.length == 8) {
    const dig = ci[ci.length - 1];
    return dig == validationDigit(ci) ? null : { ciInvalid: true };
  } else {
    return {
      ciInvalid: true
    };
  }
}

function validationDigit(ci: string) {
  var a = 0;
  var i = 0;
  if (ci.length <= 7) {
    for (i = ci.length; i < 8; i++) {
      ci = '0' + ci;
    }
  }
  for (i = 0; i < 7; i++) {
    a += (parseInt('2987634'[i]) * parseInt(ci[i])) % 10;
  }
  if (a % 10 === 0) {
    return 0;
  } else {
    return 10 - (a % 10);
  }
}
